function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Draggable from 'vuedraggable';
import i18n from "@/utils/i18n";
import FieldComponents from '@/components/form-designer/form-widget/field-widget/index';
import refMixinDesign from "@/components/form-designer/refMixinDesign";
export default {
  name: "TableCellWidget",
  componentName: "TableCellWidget",
  mixins: [i18n, refMixinDesign],
  inject: ['refList'],
  components: _objectSpread({
    Draggable: Draggable
  }, FieldComponents),
  props: {
    widget: Object,
    parentWidget: Object,
    parentList: Array,
    rowIndex: Number,
    colIndex: Number,
    rowLength: Number,
    colLength: Number,
    colArray: Array,
    rowArray: Array,
    designer: Object
  },
  computed: {
    selected: function selected() {
      return this.widget.id === this.designer.selectedId;
    },
    customClass: function customClass() {
      return this.widget.options.customClass || '';
    },
    mergeLeftColDisabled: function mergeLeftColDisabled() {
      return this.colIndex <= 0 || this.colArray[this.colIndex - 1].options.rowspan !== this.widget.options.rowspan;
    },
    mergeRightColDisabled: function mergeRightColDisabled() {
      var rightColIndex = this.colIndex + this.widget.options.colspan;
      return this.colIndex >= this.colLength - 1 || rightColIndex > this.colLength - 1 || this.colArray[rightColIndex].options.rowspan !== this.widget.options.rowspan;
    },
    mergeWholeRowDisabled: function mergeWholeRowDisabled() {
      return this.colLength <= 1 || this.colLength === this.widget.options.colspan;
    },
    mergeAboveRowDisabled: function mergeAboveRowDisabled() {
      return this.rowIndex <= 0 || this.rowArray[this.rowIndex - 1].cols[this.colIndex].options.colspan !== this.widget.options.colspan;

      //return this.rowIndex <= 0
      //return (this.rowIndex <= 0) || (this.widget.options.colspan !== this.rowArray) //TODO
    },
    mergeBelowRowDisabled: function mergeBelowRowDisabled() {
      var belowRowIndex = this.rowIndex + this.widget.options.rowspan;
      return this.rowIndex >= this.rowLength - 1 || belowRowIndex > this.rowLength - 1 || this.rowArray[belowRowIndex].cols[this.colIndex].options.colspan !== this.widget.options.colspan;
    },
    mergeWholeColDisabled: function mergeWholeColDisabled() {
      return this.rowLength <= 1 || this.rowLength === this.widget.options.rowspan;
    },
    undoMergeColDisabled: function undoMergeColDisabled() {
      return this.widget.merged || this.widget.options.colspan <= 1;
    },
    undoMergeRowDisabled: function undoMergeRowDisabled() {
      return this.widget.merged || this.widget.options.rowspan <= 1;
    },
    deleteWholeColDisabled: function deleteWholeColDisabled() {
      //return this.colLength === 1
      return this.colLength === 1 || this.widget.options.colspan === this.colLength;
    },
    deleteWholeRowDisabled: function deleteWholeRowDisabled() {
      return this.rowLength === 1 || this.widget.options.rowspan === this.rowLength;
    }
  },
  watch: {
    //
  },
  created: function created() {
    this.initRefList();
  },
  methods: {
    selectWidget: function selectWidget(widget) {
      this.designer.setSelected(widget);
    },
    checkContainerMove: function checkContainerMove(evt) {
      return this.designer.checkWidgetMove(evt);
    },
    onTableDragEnd: function onTableDragEnd(obj, subList) {
      //
    },
    onTableDragAdd: function onTableDragAdd(evt, subList) {
      //重复代码，可合并
      var newIndex = evt.newIndex;
      if (!!subList[newIndex]) {
        this.designer.setSelected(subList[newIndex]);
      }
      this.designer.emitHistoryChange();
      this.designer.emitEvent('field-selected', this.widget);
    },
    onTableDragUpdate: function onTableDragUpdate() {
      this.designer.emitHistoryChange();
    },
    selectParentWidget: function selectParentWidget() {
      if (this.parentWidget) {
        this.designer.setSelected(this.parentWidget);
      } else {
        this.designer.clearSelected();
      }
    },
    handleTableCellCommand: function handleTableCellCommand(command) {
      if (command === 'insertLeftCol') {
        this.insertLeftCol();
      } else if (command === 'insertRightCol') {
        this.insertRightCol();
      } else if (command === 'insertAboveRow') {
        this.insertAboveRow();
      } else if (command === 'insertBelowRow') {
        this.insertBelowRow();
      } else if (command === 'mergeLeftCol') {
        this.mergeLeftCol();
      } else if (command === 'mergeRightCol') {
        this.mergeRightCol();
      } else if (command === 'mergeWholeCol') {
        this.mergeWholeCol();
      } else if (command === 'mergeAboveRow') {
        this.mergeAboveRow();
      } else if (command === 'mergeBelowRow') {
        this.mergeBelowRow();
      } else if (command === 'mergeWholeRow') {
        this.mergeWholeRow();
      } else if (command === 'undoMergeCol') {
        this.undoMergeCol();
      } else if (command === 'undoMergeRow') {
        this.undoMergeRow();
      } else if (command === 'deleteWholeCol') {
        this.deleteWholeCol();
      } else if (command === 'deleteWholeRow') {
        this.deleteWholeRow();
      }
    },
    insertLeftCol: function insertLeftCol() {
      this.designer.insertTableCol(this.parentWidget, this.colIndex, this.rowIndex, true);
    },
    insertRightCol: function insertRightCol() {
      this.designer.insertTableCol(this.parentWidget, this.colIndex, this.rowIndex, false);
    },
    insertAboveRow: function insertAboveRow() {
      this.designer.insertTableRow(this.parentWidget, this.rowIndex, this.rowIndex, this.colIndex, true);
    },
    insertBelowRow: function insertBelowRow() {
      this.designer.insertTableRow(this.parentWidget, this.rowIndex, this.rowIndex, this.colIndex, false);
    },
    mergeLeftCol: function mergeLeftCol() {
      //this.designer.mergeTableColumn(this.colArray, this.colIndex, true)
      this.designer.mergeTableCol(this.rowArray, this.colArray, this.rowIndex, this.colIndex, true, this.widget);
    },
    mergeRightCol: function mergeRightCol() {
      //this.designer.mergeTableColumn(this.colArray, this.colIndex, false)
      this.designer.mergeTableCol(this.rowArray, this.colArray, this.rowIndex, this.colIndex, false, this.widget);
    },
    mergeWholeRow: function mergeWholeRow() {
      this.designer.mergeTableWholeRow(this.rowArray, this.colArray, this.rowIndex, this.colIndex);
    },
    mergeAboveRow: function mergeAboveRow() {
      this.designer.mergeTableRow(this.rowArray, this.rowIndex, this.colIndex, true, this.widget);
    },
    mergeBelowRow: function mergeBelowRow() {
      this.designer.mergeTableRow(this.rowArray, this.rowIndex, this.colIndex, false, this.widget);
    },
    mergeWholeCol: function mergeWholeCol() {
      this.designer.mergeTableWholeCol(this.rowArray, this.colArray, this.rowIndex, this.colIndex);
    },
    undoMergeCol: function undoMergeCol() {
      this.designer.undoMergeTableCol(this.rowArray, this.rowIndex, this.colIndex, this.widget.options.colspan, this.widget.options.rowspan);
    },
    undoMergeRow: function undoMergeRow() {
      this.designer.undoMergeTableRow(this.rowArray, this.rowIndex, this.colIndex, this.widget.options.colspan, this.widget.options.rowspan);
    },
    deleteWholeCol: function deleteWholeCol() {
      this.designer.deleteTableWholeCol(this.rowArray, this.colIndex);
    },
    deleteWholeRow: function deleteWholeRow() {
      this.designer.deleteTableWholeRow(this.rowArray, this.rowIndex);
    }
  }
};